import { AppBar, Toolbar, useTheme } from "@mui/material";
import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";

import { IAppState } from "../../../../store/reducers";
import { useSelector } from "react-redux";

export interface ITD1FormToolbar {
	onResetClicked: () => void;
	onDeleteClicked: () => void;
	onPrintClicked: () => void;
	isSubmitting: boolean;
	formMethods: any;
	pageTitle: string;
	id: any;
	selectedTD1EmployeeDataByIddetails: any
}
export const TD1FormToolbar: FC<ITD1FormToolbar> = ({
	onResetClicked,
	onPrintClicked,
	onDeleteClicked,
	isSubmitting = false,
	formMethods,
	pageTitle,
	id,
	selectedTD1EmployeeDataByIddetails,
}) => {
	const theme = useTheme();
	const subMenuVisibility = useSelector(
		(state: IAppState) => state.drawerAction.subMenuVisibility
	);
	const [subMenuVisibilityState, setSubMenuVisibility] = useState(subMenuVisibility)
	useEffect(() => {
		if (subMenuVisibility) {
			setSubMenuVisibility(subMenuVisibility)
		}
	}, [subMenuVisibility])
	const selectedSlip = formMethods.getValues("selectedSlip");
	const watchTD1EffectiveDate = formMethods.watch("effectiveDate");

	return (
		<AppBar
			position="sticky"
			color="default"
			elevation={1}
			sx={{
				backgroundColor: "#F7F7F7",
				paddingBottom: "16px",
				boxShadow: "none",
				zIndex: theme.zIndex.appBar + 1,
				position: "sticky",
				top: subMenuVisibility ? "112px" : "64px",
				// top: "112px",


				// when we have multiple panels means maximum scroll then it will not sticky thats why we are using here fixed position 
				// position: "fixed",
				// width:"57.25%",
				// right:"auto"

			}}
		>
			<Toolbar
				sx={{
					paddingTop: { sm: 1.75, md: 1.75, lg: 1.75, xl: 1.75 },
					paddingBottom: { sm: 0, md: 0, lg: 0, xl: 0 },
					paddingLeft: { sm: 0, md: 0, lg: 0, xl: 0 },
					paddingRight: { sm: 0, md: 0, lg: 0, xl: 0 },
					minHeight: { sm: "48px", md: "48px", lg: "48px", xl: "48px" },
					fontWeight: "700",
					display: "flex",
					justifyContent: "space-between",
				}}
			>
				<div style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
					{pageTitle}
				</div>
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>

					<EnhancedButtonPrimeReact
						label="Submit"
						loading={isSubmitting}
						type="submit"
						raised
						severity={EnhancedButtonPrimeReactSeverity.Success}
						disabled={
							selectedTD1EmployeeDataByIddetails && selectedTD1EmployeeDataByIddetails?.calculatePayroll === true &&
							watchTD1EffectiveDate <= new Date(selectedTD1EmployeeDataByIddetails.payPeriodEndDate)
						}
					/>
					<EnhancedButtonPrimeReact
						label="Reset"
						raised
						onClickHandler={onResetClicked}
						style={{ marginLeft: "1rem" }}
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
					/>
					<EnhancedButtonPrimeReact
						label="Delete"
						raised
						onClickHandler={onDeleteClicked}
						style={{ marginLeft: "1rem" }}
						severity={EnhancedButtonPrimeReactSeverity.Danger}
						disabled={
							selectedTD1EmployeeDataByIddetails && selectedTD1EmployeeDataByIddetails?.calculatePayroll === true &&
							new Date(selectedTD1EmployeeDataByIddetails?.effectiveDate) <= new Date(selectedTD1EmployeeDataByIddetails.payPeriodEndDate)
						}
					/>
					<EnhancedButtonPrimeReact
						label="Print"
						raised
						onClickHandler={onPrintClicked}
						style={{
							marginLeft: "1rem"
							// , background:"green"
						}}
						disabled={!id ? true : false}

					/>
				</div>
			</Toolbar>
		</AppBar>
	);
};
